import { render, staticRenderFns } from "./AudioSwitch.vue?vue&type=template&id=65f7e7d0&scoped=true&"
import script from "./AudioSwitch.vue?vue&type=script&lang=js&"
export * from "./AudioSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AudioSwitch.vue?vue&type=style&index=0&id=65f7e7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7e7d0",
  null
  
)

export default component.exports